import axios from "axios";
import { useState } from "react";

export const useForgotPassword = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Login function
  const forgotPassword = async (email) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post(
        `/api/forgot-password`,
        {
          grant_type: "password",
          email: email.email,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          validateStatus: function (status) {
            return status < 500; // Resolve only if the status code is less than 500
          },
        }
      );

      const data = response.data;

      if (response.status === 201) {
        // success
        console.log("Email reset password berhasil dikirim", response.data);
        setSuccess(true);
      } else if (response.status === 400 || response.status === 401) {
        setError(response.data.message || "Permintaan reset password gagal");
      } else {
        // Other errors
        setError("Unexpected error occurred");
      }

      setIsSubmitting(false);
      return data;
    } catch (error) {
      console.error("Error submitting form:", error);
      if (axios.isAxiosError(error) && error.response) {
        setError(error.response.data.message || "Failed to submit form");
      } else {
        setError("An unknown error occurred");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return { forgotPassword, isSubmitting, error, success };
};
